/* eslint-disable no-console */
import { captureMessage, captureException } from '@sentry/browser';
import { isProd } from './environments';

const logError = (...args: any[]) => {
    console.error(...args);
};

const generateHttpErrorMessage = (response: Response): void => {
    const err = response?.statusText || response?.status ? `HTTP Error: ${response.status}` : 'Unknown error';
    if (isProd) {
        captureMessage(err);
    } else {
        logError(err);
    }
};

const generateRuntimeErrorMessage = (error: Error) => {
    if (isProd) {
        captureException(error);
    }

    const err = `Runtime Error: ${error.name}, ${error.message}, ${error.cause}, ${error.stack}`;
    logError(err);
};

const logWarning = (message: string) => {
    if (isProd) {
        captureMessage(message, 'warning');
    } else {
        console.warn(message);
    }
};

export { logError, logWarning, generateHttpErrorMessage, generateRuntimeErrorMessage };
